<template>
<div>
  <template v-if="isShowBasicMessage">
  <pt-sub-title title="基本信息"></pt-sub-title>
  <div :class="$style['basic-message']">
    <wt-table v-if="canApprovalUsers.length>0" :labels="tableLabels" :list="canApprovalUsers">
    </wt-table>
  </div>
  </template>
  <pt-sub-title title="审核操作" v-if="!refundDialog||!showRefund"></pt-sub-title>
  <review-opretion v-model="form" ref="form" :auditState="auditStatus" :selectTab="selectTab" :userType="userType" :auditAlreadyRefund="auditAlreadyRefund"
  :isBatch="isBatch" :isRefundReject="isRefundReject" :rejectMethods="rejectMethods" :isRefund="isRefund" :isRefundCompleted="isRefundCompleted"
  :refundDialog="refundDialog"></review-opretion>
  <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">确认</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
  </div>
</div>
</template>
<script>
import { integralRewardLabels } from './points-reward-option'
import reviewOpretion from '../pt-award-audit/review-opretion'
export default {
  computed: {
    tableLabels () {
      return integralRewardLabels
    },
    formValue () {
      return this.$refs.form
    },
    // 是否显示基本信息
    isShowBasicMessage () {
      return this.fromPage !== 'detail' && this.isManualReward
    }
  },
  props: {
    userType: {
      type: String,
      default: null
    },
    selectTab: {
      type: String,
      default: null
    },
    selectRows: {
      type: Array,
      default: function () {
        return []
      }
    },
    statisticsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isBatch: {
      type: Boolean,
      default: false
    },
    isManualReward: {
      type: Boolean,
      default: false
    },
    auditStatus: {
      type: String,
      default: null
    },
    auditAlreadyRefund: {
      type: Boolean
    },
    refundDialog: {
      type: Boolean
    },
    fromPage: {
      type: String
    }
  },
  components: {
    reviewOpretion
  },
  data () {
    return {
      form: {
        ids: []
      },
      submitLoading: false,
      canApprovalUsers: [],
      ids: [],
      rejectMethods: null,
      isRefundReject: false,
      isRefund: false,
      showRefund: false,
      isRefundCompleted: false
    }
  },
  watch: {
    selectRows: {
      handler: function (val) {
        this.showRefund = val[0].showRefund
        val.forEach(item => {
          if (item.status === 'WAITING_FOR_APPROVAL' || item.status === 'REJECTED') {
            this.canApprovalUsers.push(item)
          }
        })
      },
      immediate: true
    }
  },
  methods: {
    submit () {
      this.formValue.validate().then(formValue => {
        this.form.ids = this.form.ids || []
        this.selectRows.forEach(item => {
          this.form.ids.push(item.id)
        })
        let data = JSON.parse(JSON.stringify(this.form))
        if (this.form.status === 'COMPLETED') {
          this.$delete(data, 'status')
          this.pointsRewardsBatchAudit(data)
        } else if (this.form.status === 'REJECTED') {
          data.reason = data.rejectReason
          this.$delete(data, 'status')
          this.$delete(data, 'rejectReason')
          this.pointsRewardsBatchRejected(data)
        }
      })
    },
    pointsRewardsBatchAudit (data) {
      this.submitLoading = true
      this.$store.dispatch('pointsRewardsBatchAudit', data).then(res => {
        this.$emit('closeDialog', true)
        this.$message.success('审核奖励积分成功')
        this.submitLoading = false
      }).catch(err => {
        this.$message.error(err || '审核奖励积分失败')
        this.submitLoading = false
      })
    },
    pointsRewardsBatchRejected (data) {
      this.submitLoading = true
      this.$store.dispatch('pointsRewardsBatchRejected', data).then(res => {
        this.$emit('closeDialog', true)
        this.$message.success('驳回奖励积分成功')
        this.submitLoading = false
      }).catch(err => {
        this.$message.error(err || '驳回奖励积分失败')
        this.submitLoading = false
      })
    },
    cancel () {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style module lang="less">
.basic-message{
  padding: 0 20px
}
</style>
